export default {
  breadcrumbsLabels: {
    '/': 'TOP',
    '/mypage/login': 'ご注文の確認',
    '/mypage/history': 'ご注文の確認',
    '/about/payment': 'お支払い方法について',
    '/about/delivery': '配送方法について',
    '/about/gift': '宿泊ギフト券の使い方',
    '/terms': '利用規約',
    '/faq': 'よくあるご質問',
    '/specified': '特定商取引法等について',
    '/contact': 'お問い合わせ'
  },
  header: {
    aboutPayment: '支払い方法',
    aboutDelivery: '配送方法',
    aboutReceipt: '領収書/請求書',
    faq: 'よくあるご質問',
    checkFromOrderNumber: '注文確認',
    aboutGift: '宿泊ギフト券の使い方',
    purchaseGiftCard: '注文する'
  },
  footer: {
    officialSite: '星野リゾート公式サイト',
    personalInfo: '個人情報の取り扱い',
    termsOfService: '利用規約',
    aboutSpecifiedCommercialTransactionLaw: '特定商取引法等について',
    description: '星野リゾート宿泊ギフト券は、㈱ドキドキ旅行が発行しています。',
    copyright: '©HOSHINO RESORTS INC.'
  },
  validationMessages: {
    required: '※ 必須項目です。',
    mustBeNumber: '※ 半角数値のみで入力してください。',
    characterPattern: '※ 漢字仮名、英字で入力してください。',
    kanaPattern: '※ カタカナ、英字で入力してください。',
    emailPattern: '※ メールアドレスを正しく入力してください。',
    alphanumericPattern: '※ 半角英数字で入力してください。',
    postcodePattern: '※ 郵便番号を正しく入力してください。',
    alphaPattern: '※ 英字で入力してください。',
    breakMaxLength: '※ 改行は最大10行までです。',
    surrogatePairPattern: '※ 絵文字または特殊文字が含まれています。',
    emptyOrderNumber: '※ 注文番号を入力してください。',
    emptyPassword: '※ パスワードを入力してください。',
    payerName: '※ カタカナ、英字のみで入力してください。'
  },
  errors: {
    sessionExpiredError: 'セッションの有効期限が切れました。',
    noSessionError: '不正な操作です。',
    loadDataError: '不正な操作です。',
    networkError:
      'ネットワークエラーが発生しました。しばらくしてから操作し直してください。'
  },
  dateFormat: {
    datepicker: 'Y-m-d',
    altFormatForDatepicker: 'Y年m月d日',
    default: 'YYYY-MM-DD',
    creditCardExpires: 'YYYYMM',
    dateName: 'YYYY年MM月DD日'
  },
  honorific: '様',
  postcode: '〒',
  tel: '電話番号',
  email: 'メールアドレス',
  giftCard: 'ギフト券',
  yen: '円',
  sheet: '枚',
  required: '必須',
  yearSuffix: '年',
  monthSuffix: '月',
  edit: '編集',
  save: '保存',
  delete: '削除',
  none: 'なし',
  notInput: '未入力',
  complete: '完了',
  confirm: '確認',
  cancel: 'キャンセル',
  ok: 'OK',
  inscriptionLabel: '[表書き]',
  shipperNameLabel: '[名入れ]',
  characters: '文字',
  lines: '行',
  preview: 'プレビュー確認',
  publish: '発行'
};



// WEBPACK FOOTER //
// ./src/i18n/ja/common.js